import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import WorkshopDetailsModal from './workshopDetailsModal';

const ONLINE_DETAILS_OWNER = '/provider/my_workshop/';
const ONLINE_EDIT = '/createworkshop/';
const ONLINE_DETAILS = '/details/online/';


const REGULAR_DETAILS_OWNER = '/provider/regular/';
const REGULAR_EDIT = '/createregular/';
const REGULAR_DETAILS = '/details/regular/';

const LIVE_EDIT = '/createwebinar/';
const PUBLIC_WEBINAR_EDIT = '/createpublicwebinar/';
const PUBLIC_WORKSHOP_EDIT = '/createpublicworkshop/';
const ORGANIZATION_EDIT = '/createorganization/'

@withRouter
export default class WorkshopButtons extends React.Component {
  constructor() {
    super();

    this.state = {
      isModalOpened: false,
      modalType: '',
    };
  }

  handleModal = event => {
    const modalType = event.target.name;
    this.setState({isModalOpened: true, modalType});
  }

  handleCloseModal = () => {
    this.setState({isModalOpened: false});
  }

  detailsOwner = () => {
    return this.isOnline() ? ONLINE_DETAILS_OWNER : REGULAR_DETAILS_OWNER
  };

  edit = () => {
    switch(this.props.type) {
      case 'online':
        return ONLINE_EDIT;
      case 'live':
        return LIVE_EDIT;
      case 'group_supervision':
        return PUBLIC_WEBINAR_EDIT;
      case 'organization':
        return ORGANIZATION_EDIT;
      case 'public_workshop':
        return PUBLIC_WORKSHOP_EDIT;
      default:
        return REGULAR_EDIT;
    }
    // return this.isOnline() ? ONLINE_EDIT : REGULAR_EDIT
  };

  details = () => {
    return this.isOnline() ? ONLINE_DETAILS : REGULAR_DETAILS
  };

  isOnline = () => {
    return this.props.type === 'online';
  };

  handleDelete = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleDelete()
  };

  handleEdit = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.history.push(`${this.edit()}${this.props.id}`);
  };

  owner = () => {
    const {isModalOpened, modalType} = this.state;
    return (
      <div className="card-btn-holder">
        {this.props.admin && (
          <a href="#" className="delete card-btn card-btn-delete" onClick={this.handleDelete}>
            <i className="ic-trash-ico" />
          </a>
        )}
        <span onClick={this.props.handleDetails}//to={this.detailsOwner() + this.props.id}
              className="btn bordered empty card-more card-btn workshop-item-buttons">
          details
        </span>
        <Link to={`${this.edit()}${this.props.id}`}
              className="btn bordered prime card-btn workshop-item-buttons"
              onClick={this.handleEdit}>
          edit
        </Link>
        <button
          name="attendees"
          className="btn bordered prime card-btn workshop-item-buttons"
          onClick={this.handleModal}>
          Attendees
        </button>
        <button
          name="attendees_refunded"
          className="btn bordered prime card-btn workshop-item-buttons"
          onClick={this.handleModal}>
          Attendees Refunded
        </button>
        <button
          name="cpd"
          className="btn bordered prime card-btn workshop-item-buttons"
          onClick={this.handleModal}>
          CPD
        </button>
        <button
          name="cpd_pending"
          className="btn bordered prime card-btn workshop-item-buttons"
          onClick={this.handleModal}>
          CPD Pending
        </button>
        {isModalOpened && (
          <WorkshopDetailsModal
            modalOpened={isModalOpened}
            closeModal={this.handleCloseModal}
            modalType={modalType}
            id={this.props.id}
          />
        )}
      </div>
    );
  };

  notOwner = () => {
    return (<div className="card-btn-holder">
      {this.props.admin ?
        [
          <a key="dsas" href="#" className="delete card-btn card-btn-delete" onClick={this.handleDelete}>
            <i className="ic-trash-ico" />
          </a>,
        <Link  key="123" to={'/admin/details/' + this.props.id}
              className="btn bordered empty card-online-public card-btn">
          details
        </Link>,
        <Link key="312" to={`${this.edit()}${this.props.id}`}
          className="btn bordered prime card-btn"
          onClick={this.handleEdit}>
          edit
        </Link>
        ]
        :
        (
          this.props.emptyUser ?
            <span className="btn bordered empty card-online-public card-btn" onClick={this.props.handleDetails}>
              details
            </span>:
        <span onClick={this.props.handleDetails}// ? '/newuser/signin' :   (this.details() + this.props.id)}
              className="btn bordered empty card-online-public card-btn">
          details
        </span>)
      }
    </div>)
  };

  render(){
    return(
      this.props.owner? this.owner() : this.notOwner()
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/WorkshopButtons.jsx